import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=57cb0858&scoped=true&"
import script from "./Posts.vue?vue&type=script&lang=js&"
export * from "./Posts.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Posts.vue?vue&type=style&index=1&lang=scss&module=true&"
import style2 from "./Posts.vue?vue&type=style&index=2&id=57cb0858&scoped=true&lang=css&"
import style3 from "./Posts.vue?vue&type=style&index=3&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "57cb0858",
  null
  
)

export default component.exports